export const useContentFieldValue = (fieldDefinitionKey, contentFields) => {

    const data = contentFields && contentFields.find((contentField) => contentField.fieldDefinitionKey === fieldDefinitionKey);

    if (data) {
        try {
            return JSON.parse(data.data);
        } catch (e) {
            return data.data;
        }
    }
    return false
};



// WEBPACK FOOTER //
// ./src/frontend/helpers/hooks/useContentFieldValue.js